module.exports = __webpack_public_path__ + "static/media/solar-green-club.2f05b220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logos/solar-green-club.jpg
// module id = 936
// module chunks = 0